<nav
  class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent"
>
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-toggle">
        <button type="button" class="navbar-toggler" (click)="sidebarToggle()">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <breadcrumb #parent>
        <ol class="breadcrumb mb-0 pl-0">
          <ng-template ngFor let-route [ngForOf]="parent.breadcrumbs">
            <li *ngIf="!route.terminal" class="breadcrumb-item">
              <a href="" [routerLink]="[route.url]">{{ route.displayName }}</a>
            </li>
            <li
              *ngIf="route.terminal"
              class="breadcrumb-item active"
              aria-current="page"
            >
              {{ route.displayName }}
            </li>
          </ng-template>
        </ol>
      </breadcrumb>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      (click)="collapse()"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseExample"
    >
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <div
      class="collapse navbar-collapse justify-content-end"
      id="collapseExample"
      [ngbCollapse]="isCollapsed"
    >
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link btn-rotate" href="javascript:void(0)">
            <i class="fa fa-sign-out-alt" (click)="logout()"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
